export default __webpack_public_path__ + "static/media/18_gallery.8e284c68.jpg";